import { Action } from '@ngrx/store';
import { InvoiceDownloadAPI } from '../../models/invoices/invoice-download-api';
import { Sorting, IInvoiceModel } from '../../models/invoices/invoices.model';

export const GET_INVOICES = '[INVOICES] Get Invoices';
export const GET_INVOICES_SUCCESS = '[INVOICES] Get Invoices Success';
export const GET_INVOICES_ERROR = '[INVOICES] Get Invoices Error';
export const SORT_INVOICES_INIT = '[INVOICES] Sort Invoices init';
export const SORT_INVOICES_COMPLETED = '[INVOICES] Sort Invoices completed';

export class GetInvoices implements Action {
  readonly type = GET_INVOICES;
}

export class SortInvoicesInit implements Action {
  readonly type = SORT_INVOICES_INIT;
  constructor(public payload: Sorting) {}
}

export class SortInvoicesCompleted implements Action {
  readonly type = SORT_INVOICES_COMPLETED;
  constructor(public payload: IInvoiceModel[]) {}
}

export class GetInvoicesSuccess implements Action {
  readonly type = GET_INVOICES_SUCCESS;
  constructor(public payload: InvoiceDownloadAPI.IInvoiceResponse[]) {}
}

export class GetInvoicesError implements Action {
  readonly type = GET_INVOICES_ERROR;
  constructor(public payload: string) {}
}

export type InvoicesAction =
  | GetInvoices
  | GetInvoicesSuccess
  | GetInvoicesError
  | SortInvoicesInit
  | SortInvoicesCompleted;
